import {useState,useEffect} from 'react'
import {Outlet,useLocation} from 'react-router-dom'
import Dashboard_Header from '../core/common/dashboard-header'
import Dashboard_Sidebar_Admin from '../core/common/dashboard-sidebar/admin'
import Dashboard_Sidebar_User from '../core/common/dashboard-sidebar/user'
import Dashboard_Sidebar_App from '../core/common/dashboard-sidebar/app'
import Cursor from '../core/common/cursor'
import BackToTop from '../core/common/backToTop'
import {all_routes} from './router/all_routes'
/* -- biz9 import start -- */
import {UrlQuery} from "biz9-react-utility";
import {Log,Str} from "biz9-utility";
import {User_Title,User_Logic,User_Role} from "biz9-user";
import {Field,Message,Title,Type,Url} from "../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../project";
/* -- biz9 import end -- */
const User_Dashboard_Feature = () => {
  const query = UrlQuery();
  const routes = all_routes;
  const location = useLocation();
  const [user,setUser] = useState(User.get());
  const [hide_side_bar,setHideSideBar] = useState(location.pathname!="/dashboard/sub_value/edit/pop_open" ? false : true);
  const [hide_header,setHideHeader] = useState(location.pathname!="/dashboard/sub_value/edit/pop_open" ? false : true);
  const [side_bar_dash_select,setSideBarDashSelect] = useState(Storage.get_dashboard_side_bar_type());
  const [dashboard_type,setDashBoardType] = useState(Storage.get_dashboard_type());
  useEffect(() => {
    setSideBarDashSelect(Storage.get_dashboard_side_bar_type());
    setDashBoardType(Storage.get_dashboard_type());
        const body = document.body;
    }, [location.pathname,hide_side_bar,Storage.get_dashboard_side_bar_type(),Storage.get_dashboard_type()]);
    const updateDashboard = (dashboard_type) => {
        setDashBoardType(dashboard_type);
    };
  return (
    <>
      <div className={`main-wrapper ${location.pathname === '/buyer/buyer-messages' ? 'chat-wrapper' : ''}`}>
        <Dashboard_Header onUpdate={updateDashboard} dashboard_type={dashboard_type} hide_header={hide_header}/>

          {user.role == User_Role.SUPER_ADMIN && dashboard_type == Type.DASHBOARD_USER &&
            (<Dashboard_Sidebar_Admin side_bar_select={side_bar_dash_select} hide_side_bar={hide_side_bar}/>)
          }
  		  {user.role == User_Role.USER && dashboard_type == Type.DASHBOARD_USER &&
            (<Dashboard_Sidebar_User side_bar_select={side_bar_dash_select} hide_side_bar={hide_side_bar}/>)
          }
         {dashboard_type == Type.DASHBOARD_APP &&
            (<Dashboard_Sidebar_App side_bar_select={side_bar_dash_select} hide_side_bar={hide_side_bar}/>)
          }
        <Outlet />
        <Cursor />
        <BackToTop />
      </div>
    </>
  )
}
export default User_Dashboard_Feature;
